import { render, staticRenderFns } from "./iinsurance.vue?vue&type=template&id=3c5c95b1&"
import script from "./iinsurance.vue?vue&type=script&lang=js&"
export * from "./iinsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports